// removed by extract-text-webpack-plugin
module.exports = {"navFrame":"src-components-SideBar----sidebar-module---navFrame---E-iZr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideBar/sidebar.module.css
// module id = 679
// module chunks = 6674870452060